export const LIVE_PROCESS_STATUS = {
  PENDING    : 'pending',
  DISABLED   : 'disabled',
  READY_LIVE : 'ready_live',
  COMPLETED  : 'completed'
}

export const PUT_AWAY_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}
